export default __webpack_public_path__ + "static/media/welcome-photo.37afe9a9.svg";